export default "__VITE_PUBLIC_ASSET__ebd73839__"